// Объединяет параллельные вызовы одной асинхронной операции в общий Promise.
export function createSingleFlight() {
  let activeRequest = null;

  return (task) => {
    if (activeRequest) return activeRequest;

    activeRequest = Promise.resolve()
      .then(task)
      .finally(() => {
        activeRequest = null;
      });

    return activeRequest;
  };
}
